interface SiteIdentityRefs {
	organization: { "@id"?: string };
	website: { publisher?: { "@id": string } };
}

/**
 * The retailer Organization's "@id". It must be absolute: unhead files any
 * other id under its own `#/schema/organization/` fragment, which gave the
 * malformed `/#/schema/organization/#organization` (GF-91).
 */
export const organizationId = (siteUrl: string): string =>
	`${siteUrl.replace(/\/+$/, "")}/#organization`;

/**
 * unhead treats an Organization without its own "@id" as the site identity
 * ("#identity") and then fills every Product's empty `brand` with it. Right for
 * a single-brand store; for a retailer it names the shop as the maker of every
 * product, so those keep a separate id and link WebSite.publisher by hand.
 */
export const siteIdentityRefs = (
	asIdentity: boolean,
	siteUrl: string
): SiteIdentityRefs => {
	if (asIdentity) return { organization: {}, website: {} };

	const id = organizationId(siteUrl);
	return {
		organization: { "@id": id },
		website: { publisher: { "@id": id } }
	};
};
